// extracted by mini-css-extract-plugin
export default {"locohomehost11":"LocoHomeHost_locohomehost11__TeTrw"};